import { IEquipmentWithoutProduct } from '@models/Equipment.model';
import { IFieldConfiguration } from '@models/FieldConfiguration.model';
import ReactTooltip from 'react-tooltip';
import { Items } from '../../../Data/utils';
import {
  Avatar,
  DataLink,
  TextRight,
  ToolTipDivPinned,
} from './PinnedField.styles';
import { MembersQueryResult } from './PinnedField.types';

export interface TextRightContentProps {
  item: IFieldConfiguration;
  equipment: IEquipmentWithoutProduct;
  value: string;

  membersQuery?: MembersQueryResult;
}
/**
 * Component that renders the content of any PinnedField in inventory.
 */
export function PinnedFieldContent(props: TextRightContentProps) {
  const { item, equipment, value, membersQuery } = props;
  const { fieldName } = item;

  if (fieldName === 'productPage') {
    return (
      <DataLink href={value} target="_blank" rel="noopener noreferrer">
        Link
      </DataLink>
    );
  }

  if (fieldName === 'userName' && membersQuery?.data) {
    return (
      <>
        <Avatar
          src={
            membersQuery.data.find(user => user.id === equipment.user?.id)
              ?.picture
          }
        />
        {value}
      </>
    );
  }
  // todo: Combine formatter api and fieldConfig
  if (fieldName === 'productStatus') {
    const statusFormatter = Items.find(itemValue => {
      return itemValue.fieldName === fieldName;
    });
    if (statusFormatter && statusFormatter.formatter) {
      return <>{statusFormatter.formatter(value, { equipment })}</>;
    }
  }

  return (
    <>
      <TextRight data-tip data-for={`tooltip${item.id}`}>
        {value}
      </TextRight>
      <ReactTooltip
        className="tooltip"
        id={`tooltip${item.id}`}
        effect="solid"
        backgroundColor="#161A30"
        multiline
      >
        <ToolTipDivPinned>
          Only internal data and assignee can be edited.
        </ToolTipDivPinned>
      </ReactTooltip>
    </>
  );
}
